import { ApiLanguage } from "@/services/languages/schemas"

/**
 * localizeLanguage
 */
export const localizeLanguage = (parsed: ApiLanguage) => ({
  ...D.selectKeys(parsed, ["id", "name", "code", "locale", "status"]),
})
export type Language = ReturnType<typeof localizeLanguage>
